// @flow
import { type Country } from '@tectonics/prs/country';
import { getTranslateErrorMessage } from './error-messages';

export function mapServerError(errorCode: string, country: Country): ?string {
  const translateErrorMessage = getTranslateErrorMessage(country);
  return translateErrorMessage(errorCode);
}
